<template>
  <ul class="nav-links">
    <li v-for="list in navLinks" :key="list.key" class="nav-item">
      <a
        v-if="list.dropdown === false && list.target !== '_blank'"
        :href="list.link"
        role="button"
        aria-haspopup="true"
        aria-expanded="false"        
        >{{ list.name }}</a>
      <a :href="list.link" v-else-if="list.target == '_blank'" target="_blank" >{{ list.name }}</a>
      <a class="dropdown-link" href="javascript:void(0)" v-else>
          {{ list.name }}
          <svg alt="" aria-hidden="true" width="24" height="16" xmlns="http://www.w3.org/2000/svg" class="bi bi-chevron-down" fill="#003c5d">
              <g>
                  <title>Layer 1</title>
                  <path stroke-width="3" id="svg_1" d="m10.29591,8.73371a0.4318,0.4318 0 0 1 0.61143,0l4.87589,4.87675l4.87589,-4.87675a0.4318,0.4318 0 0 1 0.61143,0.61143l-5.1816,5.1816a0.4318,0.4318 0 0 1 -0.61143,0l-5.1816,-5.1816a0.4318,0.4318 0 0 1 0,-0.61143z" fill-rule="evenodd" />
              </g>
          </svg>
          <!--<span>&#x2193;</span>-->
          <ul class="dropdown-menu">
              <li v-for="(item, i) in list.dropdownLinks" :key="item.key">
                  <a v-if="i !== list.dropdownLinks.length - 1"
                     :href="item.link"
                     :target="item.target"
                     role="button"
                     aria-haspopup="true"
                     aria-expanded="false">{{ item.name }}</a>
                  <a v-else
                     :href="item.link"
                     role="button"
                     :target="item.target"
                     aria-haspopup="true"
                     aria-expanded="false"
                     @blur="closeMe">{{ item.name }}</a>
              </li>
          </ul>
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "MenuBar",
  props: ["name", "logoImg", "navLinks"],
  methods: {
    openDropdownNav() {
      const dropdownLink = document.querySelectorAll(".dropdown-link");
      dropdownLink.forEach((dropdown) => {
        dropdown.addEventListener("click", () => {
          dropdown.children[1].style.display = "block";
        });
        dropdown.addEventListener("mouseover", () => {
          dropdown.children[1].style.display = "block";
        });
        dropdown.addEventListener("mouseleave", () => {
          dropdown.children[1].style.display = "none";
        });
      });
    },
    closeMe() {
      const dropdownLink = document.querySelectorAll(".dropdown-link");
      dropdownLink.forEach((dropdown) => {
        dropdown.children[1].style.display = "none";
      });
    },
    /* Run only on mobileS
       
       This code below here will change the behavior of mobile menu links.
       when you click for once it will open the drop down & by the
       second click it will lead you to the link page if you don't
       want to go in dropdown links
    */
    countClicksOnMobileDropdown() {
      const dropdownLink = document.querySelectorAll(".dropdown-link");
      dropdownLink.forEach((dropdown) => {
        let counts = dropdown.clicks || 0;
        dropdown.addEventListener("click", () => {
          counts++;
          if (counts % 2 == 0) {
            if(dropdown.children[0].getAttribute("href")){
              window.location.href = dropdown.children[0].getAttribute("href");
            }
          } else {
            event.preventDefault();
            dropdown.children[1].style.display = "block";
            setTimeout(() => {
              dropdown.children[1].style.display = "none";
            }, 5000);
          }
        });
        setTimeout(() => {
          counts = 0;
        }, 8000);
      });
    },
  },
  mounted() {
    this.openDropdownNav();
    if (window.innerWidth < 768) {
      this.countClicksOnMobileDropdown();
    }
  },
};
</script>

<style>
.dropdown-link{
  display: block;
  padding-bottom: 1.3rem;
  text-align: left;
}
@keyframes navLinkFade {
  from {
    opacity: 0;
    transform: translateX(-60px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
</style>
